import script from "./EmptyModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyModule.vue?vue&type=script&setup=true&lang=ts"

import "./EmptyModule.vue?vue&type=style&index=0&id=45bb58e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45bb58e4"]])

export default __exports__